var map = {
	"./clients/bharatagri.png": 43464,
	"./clients/bizongo.svg": 39490,
	"./clients/leapfinanace.svg": 11341,
	"./clients/lenden.png": 36397,
	"./clients/lenden.svg": 86578,
	"./clients/mosaicwellness.png": 32166,
	"./clients/shiprocket.png": 90009,
	"./clients/shiprocket.svg": 35438,
	"./clients/slice.svg": 40358,
	"./clients/sugarcosmetics.svg": 48310,
	"./clients/testbook.svg": 97739,
	"./clients/yulu.png": 38232,
	"./clients/yulu.svg": 69399,
	"./congrats.svg": 53372,
	"./covers/blr-min.jpg": 86742,
	"./covers/coffee-shop-1.jpg": 67962,
	"./covers/cover-10.jpg": 72668,
	"./covers/cover-9.jpg": 13966,
	"./covers/dots.png": 98453,
	"./covers/pricing-cover.png": 94425,
	"./devices/iphonex.png": 66399,
	"./devices/iphonex.svg": 94672,
	"./devices/macbook.png": 96736,
	"./devices/macbook.svg": 25871,
	"./eqty-images/icons/Check.svg": 57841,
	"./eqty-images/icons/SuccessCheck.svg": 56604,
	"./guilloche-background.svg": 56400,
	"./icons/social/facebook.svg": 55682,
	"./icons/social/instagram.svg": 88486,
	"./icons/social/pinterest.svg": 65748,
	"./icons/social/twitter.svg": 89183,
	"./illustrations/illustration-1-cropped.png": 86394,
	"./illustrations/illustration-1.png": 79780,
	"./illustrations/illustration-2.png": 34431,
	"./illustrations/illustration-3-cropped.png": 63432,
	"./illustrations/illustration-3.png": 38102,
	"./illustrations/illustration-4-cropped.png": 7731,
	"./illustrations/illustration-4.png": 37929,
	"./illustrations/illustration-5.png": 83104,
	"./illustrations/illustration-6-cropped.png": 36537,
	"./illustrations/illustration-6.png": 61435,
	"./illustrations/illustration-7.png": 24837,
	"./illustrations/illustration-8.png": 98754,
	"./masks/avatar-group-hover-last.svg": 47754,
	"./masks/avatar-group-hover.svg": 23713,
	"./masks/avatar-group.svg": 56946,
	"./masks/avatar-status.svg": 1757,
	"./screenshots/desktop/captable.png": 94717,
	"./screenshots/desktop/company-small.png": 37558,
	"./screenshots/desktop/dataroom.png": 54860,
	"./screenshots/desktop/employee-small.png": 29519,
	"./screenshots/desktop/value.png": 28526,
	"./shapes/angles/angle-bottom.svg": 18232,
	"./shapes/angles/angle-left.svg": 55402,
	"./shapes/angles/angle-right.svg": 97889,
	"./shapes/angles/angle-top.svg": 76162,
	"./shapes/blurs/blur-1.svg": 47176,
	"./shapes/blurs/blur-2.svg": 28539,
	"./shapes/blurs/blur-3.svg": 86570,
	"./shapes/blurs/blur-4.svg": 58197,
	"./shapes/curves/curve-1.svg": 80890,
	"./shapes/curves/curve-2.svg": 49001,
	"./shapes/curves/curve-3.svg": 44760,
	"./shapes/curves/curve-4.svg": 33943,
	"./shapes/curves/curve-5.svg": 19558,
	"./shapes/curves/curve-6.svg": 41989,
	"./shapes/waves/wave-1.svg": 2572,
	"./testimonials/bizongo.svg": 34868,
	"./testimonials/slice.svg": 61235,
	"./trix/chart-icon.svg": 65759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 78541;